import { CoralogixRum } from '@coralogix/browser'

import type { User } from '@/features/user/types/user'

export function setCoralogixUserContext(user: User) {
  CoralogixRum.setUserContext({
    user_id: user.id ?? '',
    user_name: user.username ?? '',
    user_metadata: {
      role: user.role,
    },
  })
}

// The Coralogix SDK has no clearUserContext API; overwrite with empty values to drop the prior user.
export function clearCoralogixUserContext() {
  CoralogixRum.setUserContext({
    user_id: '',
    user_name: '',
    user_metadata: {},
  })
}
